import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveUnReadNotificationsNbrRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveUnReadNotificationsNbrRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveUnReadNotificationsNbrRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getUnReadNotificationsNbr() {
      return getState().nbr;
    },
  };
}

export { createSelector };
